import axios from 'axios';
import { captureException } from '@sentry/react';

import { CHEAPER_OPTION_ACTIONS } from './constants';

// SEND DATA ACTIONS
export const sendCheaperOptionStart = () => ({
  type: CHEAPER_OPTION_ACTIONS.SEND_CHEAPER_OPTION,
});

export const sendCheaperOptionSuccess = () => ({
  type: CHEAPER_OPTION_ACTIONS.SEND_CHEAPER_OPTION_SUCCESS,
});

export const sendCheaperOptionError = () => ({
  type: CHEAPER_OPTION_ACTIONS.SEND_CHEAPER_OPTION_ERROR,
});
// FETCH DATA ACTIONS
export const fetchCheaperOptionTextsSuccess = (payload) => ({
  type: CHEAPER_OPTION_ACTIONS.FETCH_CHEAPER_OPTION_TEXTS_SUCCESS,
  payload,
});

export const sendCheaperOptionThunk = (payload) => async (dispatch) => {
  dispatch(sendCheaperOptionStart());

  try {
    const { data } = await axios.post('/shop/basket/check-better-price', {
      json: JSON.stringify({
        ...payload,
      }),
    });

    const callbackAction = data?.IsSucceeded ? sendCheaperOptionSuccess : sendCheaperOptionError;

    dispatch(callbackAction());
  } catch (error) {
    captureException(error);
    dispatch(sendCheaperOptionError());
  }
};

export const fetchCheaperOptionTextsThunk = () => async (dispatch) => {
  try {
    const { data } = await axios.get('/shop/sitetext/?key=SHOP_BASKET_BEST_PRICE');
    const stringData = data.replace(/\s/g, ' ').match(/\{(.*)\}/);
    const texts = JSON.parse(stringData[0]);

    dispatch(fetchCheaperOptionTextsSuccess(texts));
  } catch (error) {
    captureException(error);
  }
};
